// Limit concurrent row lookups while retaining the table's original sort order.
export const mapDashboardRows = async (rows, loadRow, concurrency = 6) => {
  const results = new Array(rows.length);
  let nextIndex = 0;
  await Promise.all(Array.from({ length: Math.min(concurrency, rows.length) }, async () => {
    while (nextIndex < rows.length) {
      const index = nextIndex++;
      results[index] = await loadRow(rows[index]);
    }
  }));
  return results;
};

// Share overlapping reads only; later refreshes must request fresh data.
export const shareDashboardRequest = (pending, key, load) => {
  if (!pending.has(key)) {
    const request = Promise.resolve().then(load).finally(() => pending.delete(key));
    pending.set(key, request);
  }
  return pending.get(key);
};
